import { Fragment } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useMostRecentExamAttempt } from '../../exams';
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useExamRulesState } from '../examsStores';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RetakeExamButton = ({
  cooldownHourCount = 12,
  use,
  withTooltip,
  trackId,
  language,
  ctaText
}) => {
  const {
    mostRecentExamAttempt
  } = useMostRecentExamAttempt(Number(trackId), language);
  const {
    setShowExamRules
  } = useExamRulesState();
  const isInCooldown = mostRecentExamAttempt && mostRecentExamAttempt.attemptRetakeTime > getServerSyncedTime();
  const button = /*#__PURE__*/_jsx(Button, {
    disabled: !!isInCooldown,
    onClick: () => setShowExamRules(true),
    use: use,
    children: ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.retakeButton"
    })
  });
  if (isInCooldown) {
    if (withTooltip) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.exams.rules.cooldownHourDurationCount",
          options: {
            cooldownHourCount
          }
        }),
        children: button
      });
    } else {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [button, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.exams.rules.cooldownHourDurationCount",
            options: {
              cooldownHourCount
            }
          })
        })]
      });
    }
  }
  return button;
};
export default RetakeExamButton;